export const IBoAeFolderAlerts = Object.freeze({
  code: "code", // "MISSING_KYC_FIELD",
  type: "type", // "Extra | Kyc"
  color: "color", // "extra-dark-red",
  description: "text", // "KYC Champs manquants"
  tooltip: "tooltip", // "siretNumber, ibanNumber"
});

export class BoAeFolderAlertsModel {
  constructor(data = {}) {
    this[IBoAeFolderAlerts.code] = data[IBoAeFolderAlerts.code];
    this[IBoAeFolderAlerts.type] = data[IBoAeFolderAlerts.type];
    this[IBoAeFolderAlerts.color] = data[IBoAeFolderAlerts.color];
    this[IBoAeFolderAlerts.description] = data[IBoAeFolderAlerts.description];
    this[IBoAeFolderAlerts.tooltip] = data[IBoAeFolderAlerts.tooltip];
  }

  getCode() {
    return this[IBoAeFolderAlerts.code];
  }

  getType() {
    return this[IBoAeFolderAlerts.type];
  }

  getDescription() {
    return this[IBoAeFolderAlerts.description];
  }

  getLabel() {
    return `${this.getType()} ${this.getDescription()}`;
  }

  getColor() {
    return this[IBoAeFolderAlerts.color];
  }

  getTooltip() {
    return this[IBoAeFolderAlerts.tooltip];
  }
}
